//Login
export const REQUEST_OTP = "REQUEST_OTP";
export const VALIDATE_OTP = "VALIDATE_OTP";
export const VERIFY_PHONE_NUMBER = "VERIFY_PHONE_NUMBER";

// General
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const MODAL_RESET = "MODAL_RESET";
export const REQUEST_ORGANIZATION_ADDRESS = "REQUEST_ORGANIZATION_ADDRESS";
export const STORE_ORGANIZATION_ADDRESS = "STORE_ORGANIZATION_ADDRESS";
export const STORE_ORGANIZATION_IMAGES = "STORE_ORGANIZATION_IMAGES";
export const SAVE_ORGANIZATION_IMAGES = "SAVE_ORGANIZATION_IMAGES";

// Sites
export const GET_SITES = "get_sites";
export const STORE_SITES = "store_sites";
export const STORE_SELECTED_SITE = "store_selected_site";
export const REQUEST_LOCATIONS = "request_locations";
export const STORE_LOCATIONS = "store_locations";
export const GET_SITE_AND_LOCATION_FOR_FAVOURITE_CONTROLLER =
  "GET_SITE_AND_LOCATION_FOR_FAVOURITE_CONTROLLER";

//Category
export const GET_CATEGORIES = "GET_CATEGORIES";
export const STORE_CATEGORIES = "STORE_CATEGORIES";

//SENSOR GROUPS AND TYPES
export const REQUEST_SENSORGROUPS_BYCATEGORY = "REQUEST_SENSORGROUPS_BYCATEGORY";
export const REQUEST_SENSORGROUPS_SAGA = "REQUEST_SENSORGROUPS_SAGA";
export const REQUEST_SENSORTYPES_SAGA = "REQUEST_SENSORTYPES_SAGA";
export const REQUEST_SENSORGROUPTYPE_SELECTED_SAGA =
  "REQUEST_SENSORGROUPTYPE_SELECTED_SAGA";
export const UPDATE_SENSORGROUPTYPE = "UPDATE_SENSORGROUPTYPE";

// Organization
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_CUSTOMER_USER_PROFILE = "GET_CUSTOMER_USER_PROFILE";
export const STORE_USER_PROFILE = "STORE_USER_PROFILE";
export const STORE_CUSTOMER_USER_PROFILE = "STORE_CUSTOMER_USER_PROFILE";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_ORGANIZATION_IMAGES = "GET_ORGANIZATION_IMAGES";
export const STORE_ORGANIZATION = "STORE_ORGANIZATION";
export const SAVE_SELECTED_CUSTOMER = "SAVE_SELECTED_CUSTOMER";

// Dashboards
export const REQUEST_DASHBOARDS = "REQUEST_DASHBOARDS";
export const STORE_DASHBOARDS = "STORE_DASHBOARDS";
export const REQUEST_DASHBOARD_CELLS_DATA = "REQUEST_DASHBOARD_CELLS_DATA";
export const STORE_DASHBOARD_CELLS_DATA = "STORE_DASHBOARD_CELLS_DATA";
export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const CREATE_DASHBOARD = "CREATE_DASHBOARD";
export const DELETE_DASHBOARD = "DELETE_DASHBOARD";
export const DELETE_DASHBOARD_CELL = "DELETE_DASHBOARD_CELL";
export const REQUEST_WIDGETS = "REQUEST_WIDGETS";
export const STORE_WIDGETS = "STORE_WIDGETS";
export const UPDATE_CELLS = "UPDATE_CELLS";
export const SNAPSHOT_HANDOFF = "SNAPSHOT_HANDOFF";
export const SNAPSHOT_CLONE = "SNAPSHOT_CLONE";

//Intercom

export const CLAIM_CONTROLLER = "claim_controller";
export const UNCLAIM_CONTROLLER = "unclaim_controller";
export const REQUEST_CONTROLLERS_SAGA = "request_controllers_saga";
export const STORE_CONTROLLERS = "store_controllers";
export const SAVE_SELECTED_CONTROLLER = "save_selected_controllers";

// Application Error
export const APPLICATION_ERROR = "application_error";

//Inventories
export const REQUEST_INVENTORIES_SAGA = "request_inventories_saga";
export const STORE_INVENTORIES = "store_inventories";
export const REQUEST_INVENTORIES_VALUE_LIST = "REQUEST_INVENTORIES_VALUE_LIST";

// Create Site Modal
export const SEND_SITE_MODAL_DATA = "send_site_modal_data";
export const SEND_LOCATION_MODAL_DATA = "send_location_modal_data";
export const STORE_SELECTED_LOCATION = "store_selected_location";

// Tools Configurations

export const REQUEST_EDIT_ETHERNET_SAGA = "request_edit_ethernet_saga";
export const REQUEST_ETHERNET_CONFIG = "REQUEST_ETHERNET_CONFIG";
export const STORE_ETHERNET_CONFIG = "store_ethernet_config";
export const STORE_WIFI_CONFIG = "store_wifi_config";

export const REQUEST_EDIT_PORT_FORWARDING_SAGA = "request_edit_port_forwarding_saga";
export const REQUEST_PORT_FORWARDING_CONFIGURATIONS =
  "REQUEST_PORT_FORWARDING_CONFIGURATIONS";
export const STORE_PORT_FORWARDING_CONFIGURATIONS =
  "STORE_PORT_FORWARDING_CONFIGURATIONS";

// TELEMETRY
export const REQUEST_TELEMETRY = "REQUEST_TELEMETRY";

// SYSTEM
export const REQUEST_SYSTEM_PROPERTIES_SAGA = "request_system_properties_saga";
export const STORE_SYSTEM_PROPERTIES = "store_system_properties";

export const REQUEST_SYSTEM_SUMMARY_DATA_SAGA = "REQUEST_SYSTEM_SUMMARY_DATA_SAGA";
export const STORE_SYSTEM_SUMMARY_DATA = "STORE_SYSTEM_SUMMARY_DATA";
export const REQUEST_SENSOR_SUMMARY_DATA = "REQUEST_SENSOR_SUMMARY_DATA";
export const STORE_SENSOR_SUMMARY_DATA = "STORE_SENSOR_SUMMARY_DATA";
export const REQUEST_SENSOR_SUMMARY_RESET_DATA = "REQUEST_SENSOR_SUMMARY_RESET_DATA";
export const SEND_EDIT_CONTROLLER_DATA_SAGA = "SEND_EDIT_CONTROLLER_DATA_SAGA";
export const REQUEST_SYSTEM_FAVOURITES = "REQUEST_SYSTEM_FAVOURITES";
export const STORE_SYSTEM_FAVOURITES = "STORE_SYSTEM_FAVOURITES";
export const REQUEST_SYSTEM_FAVOURITE = "REQUEST_SYSTEM_FAVOURITE";
export const SEND_SYSTEM_FAVOURITE = "SEND_SYSTEM_FAVOURITE";
export const STORE_SYSTEM_FAVOURITE = "STORE_SYSTEM_FAVOURITE";
export const REQUEST_ANALOG_BANK = "REQUEST_ANALOG_BANK";
export const STORE_ANALOG_BANK = "STORE_ANALOG_BANK";
export const SEND_ANALOG_BANK = "SEND_ANALOG_BANK";
export const TEST_FEED_SAGA = "TEST_FEED_SAGA";
export const ADD_SLUG_FEED_SAGA = "ADD_SLUG_FEED_SAGA";
export const REQUEST_SYSTEM_LOGS_SAGA = "REQUEST_SYSTEM_LOGS_SAGA";
export const STORE_SYSTEM_LOGS = "STORE_SYSTEM_LOGS";
export const REQUEST_SNAPSHOT = "REQUEST_SNAPSHOT";
export const STORE_SNAPSHOT = "STORE_SNAPSHOT";
export const REQUEST_INVENTORY_SENSOR = "REQUEST_INVENTORY_SENSOR";
export const STORE_INVENTORY_SENSOR = "STORE_INVENTORY_SENSOR";
export const REQUEST_INVENTORY_SENSOR_CALIBRATE_CMDS =
  "REQUEST_INVENTORY_SENSOR_CALIBRATE_CMDS";
export const STORE_INVENTORY_SENSOR_CALIBRATE_CMDS =
  "STORE_INVENTORY_SENSOR_CALIBRATE_CMDS";
export const RUN_CALIBRATION = "RUN_CALIBRATION";
export const REQUEST_INVENTORY_SENSOR_CALIBRATION_HISTORY =
  "REQUEST_INVENTORY_SENSOR_CALIBRATION_HISTORY";
export const STORE_INVENTORY_SENSOR_CALIBRATION_HISTORY =
  "STORE_INVENTORY_SENSOR_CALIBRATION_HISTORY";
export const REQUEST_MODBUS_TCP_IP = "REQUEST_MODBUS_TCP_IP";
export const STORE_MODBUS_TCP_IP = "STORE_MODBUS_TCP_IP";
export const SAVE_MODBUS_TCP_IP = "SAVE_MODBUS_TCP_IP";

export const RESET_CONTROLLER = "RESET_CONTROLLER";
export const REQUEST_CONTROLLERS_WITH_ACTIVE_ALERT =
  "REQUEST_CONTROLLERS_WITH_ACTIVE_ALERT";
export const SAVE_CONTROLLERS_WITH_ACTIVE_ALERT = "SAVE_CONTROLLERS_WITH_ACTIVE_ALERT";
export const REQUEST_AQUATIC_GROUP_PROFILES = "REQUEST_AQUATIC_GROUP_PROFILES";
export const STORE_AQUATIC_GROUP_PROFILES = "STORE_AQUATIC_GROUP_PROFILES";
export const ADD_EDIT_AQUATIC_GROUP_PROFILE = "ADD_EDIT_AQUATIC_GROUP_PROFILE";

// DATA EXPLORER
export const REQUEST_DATA_EXPLORER_TEMPLATES = "REQUEST_DATA_EXPLORER_TEMPLATES";
export const STORE_DATA_EXPLORER_TEMPLATES = "STORE_DATA_EXPLORER_TEMPLATES";
export const REQUEST_DATA_EXPLORER_ANALYSIS = "REQUEST_DATA_EXPLORER_ANALYSIS";
export const STORE_DATA_EXPLORER_ANALYSIS = "STORE_DATA_EXPLORER_ANALYSIS";
export const STORE_DATA_EXPLORER_SENSOR_ANALYSIS = "STORE_DATA_EXPLORER_SENSOR_ANALYSIS";
export const REQUEST_DATA_EXPLORER_TIMEZONES = "REQUEST_DATA_EXPLORER_TIMEZONES";
export const STORE_DATA_EXPLORER_TIMEZONES = "STORE_DATA_EXPLORER_TIMEZONES";
export const SAVE_DATA_EXPLORER_SNAPSHOT = "SAVE_DATA_EXPLORER_SNAPSHOT";
export const REQUEST_DATA_EXPLORER_SNAPSHOT = "REQUEST_DATA_EXPLORER_SNAPSHOT";
export const STORE_DATA_EXPLORER_SNAPSHOT = "STORE_DATA_EXPLORER_SNAPSHOT";

// ADDRESS

export const REQUEST_ADDRESS_SAGA = "request_address_saga";
export const STORE_ADDRESS = "store_address";

export const REQUEST_ADD_ADDRESS_SAGA = "request_add_address_saga";

export const REQUEST_UPDATE_ADDRESS_SAGA = "request_request_address_saga";

export const REQUEST_DELETE_ADDRESS_SAGA = "REQUEST_DELETE_ADDRESS_SAGA";

// Reports
export const STORE_CREATE_TEST_DATA = "STORE_CREATE_TEST_DATA";
export const STORE_CREATE_NON_TEST_DATA = "STORE_CREATE_NON_TEST_DATA";
export const STORE_CREATE_TEMPLATE_DATA = "STORE_CREATE_TEMPLATE_DATA";
export const STORE_TEST_TEMPLATE_LIST = "STORE_TEST_TEMPLATE_LIST";
export const TEST_FORM_VISIBLE = "TEST_FORM_VISIBLE";
export const NON_TEST_FORM_VISIBLE = "NON_TEST_FORM_VISIBLE";
export const STORE_REPORT_SELECTED_CONTROLLERS_LIST =
  "STORE_REPORT_SELECTED_CONTROLLERS_LIST";
export const REQUEST_RECORD = "REQUEST_RECORD";
export const REQUEST_TEMPLATE_CONTROLLERS = "REQUEST_TEMPLATE_CONTROLLERS";
export const STORE_TEMPLATE_CONTROLLERS = "STORE_TEMPLATE_CONTROLLERS";
export const REQUEST_TEST_SENSORS = "REQUEST_TEST_SENSORS";
export const STORE_TEST_SENSORS = "STORE_TEST_SENSORS";
export const REQUEST_NON_TEST_TEMPLATE = "REQUEST_NON_TEST_TEMPLATE";
export const STORE_NON_TEST_TEMPLATE = "STORE_NON_TEST_TEMPLATE";
export const CREATE_NON_TEST_TEMPLATE = "CREATE_NON_TEST_TEMPLATE";
export const REQUEST_ADD_TEMPLATE_SAGA = "REQUEST_ADD_TEMPLATE_SAGA";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const REQUEST_TEMPLATES = "REQUEST_TEMPLATES";
export const REQUEST_EACH_TEMPLATE = "REQUEST_EACH_TEMPLATE";
export const STORE_TEMPLATES = "STORE_TEMPLATES";
export const REQUEST_REPORTS_SITES = "REQUEST_REPORTS_SITES";
export const STORE_REPORTS_SITES = "STORE_REPORTS_SITES";
export const REQUEST_REPORTS_LOCATIONS = "REQUEST_REPORTS_LOCATIONS";
export const STORE_REPORTS_LOCATIONS = "STORE_REPORTS_LOCATIONS";
export const REQUEST_REPORT_CONTROLLERS = "REQUEST_REPORT_CONTROLLERS";
export const STORE_REPORT_CONTROLLERS = "STORE_REPORT_CONTROLLERS";
export const STORE_CREATE_REPORT_DATA = "STORE_CREATE_REPORT_DATA";
export const REQUEST_CREATE_REPORT = "REQUEST_CREATE_REPORT";
export const REQUEST_REPORTS_SAGA = "request_reports_saga";
export const STORE_REPORTS = "store_reports";
export const REQUEST_EACH_REPORT = "REQUEST_EACH_REPORT";
export const CHANGE_REPORT_STATUS = "CHANGE_REPORT_STATUS";
export const REQUEST_REPORT_ANALYSIS = "REQUEST_REPORT_ANALYSIS";
export const REQUEST_REPORT_PDF = "REQUEST_REPORT_PDF";
export const DELETE_REPORT = "DELETE_REPORT";
export const STORE_TEMPLATE_DATA = "STORE_TEMPLATE_DATA";
export const REQUEST_CONTROLLER_SENSOR_DATA = "REQUEST_CONTROLLER_SENSOR_DATA";
export const STORE_CONTROLLER_SENSOR_DATA = "STORE_CONTROLLER_SENSOR_DATA";
export const RESET_CONTROLLER_SENSOR_DATA = "RESET_CONTROLLER_SENSOR_DATA";

//USERS
export const SAVE_ADD_USER_MODAL_STATUS = "SAVE_ADD_USER_MODAL_STATUS";
export const SAVE_ADD_USER_MODAL_DATA = "SAVE_ADD_USER_MODAL_DATA";
export const REQUEST_SEND_ADD_USER_DATA_SAGA = "REQUEST_SEND_ADD_USER_DATA_SAGA";
export const REQUEST_GET_USERS_LIST_SAGA = "REQUEST_GET_USERS_LIST_SAGA";
export const SAVE_GET_USERS_LIST = "SAVE_GET_USERS_LIST";
export const REQUEST_SEND_EDIT_USER_DATA_SAGA = "REQUEST_SEND_EDIT_USER_DATA_SAGA";
export const REQUEST_DELETE_USER_SAGA = "REQUEST_DELETE_USER_SAGA";
export const REQUEST_ORG_USERS = "REQUEST_ORG_USERS";
export const STORE_ORG_USERS = "STORE_ORG_USERS";
export const CHANGE_OWNER = "CHANGE_OWNER";
export const REQUEST_USER_RESOURCES = "REQUEST_USER_RESOURCES";
export const STORE_USER_RESOURCES = "STORE_USER_RESOURCES";

//GROUP
export const REQUEST_GROUP_LIST_SAGA = "REQUEST_GROUP_LIST_SAGA";
export const REQUEST_ADD_GROUP_SAGA = "REQUEST_ADD_GROUP_SAGA";
export const SAVE_GROUP_LIST = "SAVE_GROUP_LIST";
export const REQUEST_PERMISSION_LIST = "REQUEST_PERMISSION_LIST";
export const REQUEST_GROUP_LABEL_VALUE_LIST = "REQUEST_GROUP_LABEL_VALUE_LIST";
export const STORE_GROUP_LABEL_VALUE_LIST = "STORE_GROUP_LABEL_VALUE_LIST";
export const SAVE_PERMISSION_LIST = "SAVE_PERMISSION_LIST";
export const REQUEST_USER_LIST = "REQUEST_USER_LIST";
export const SAVE_USER_LIST = "SAVE_USER_LIST";

export const SAVE_ADD_GROUP_MODAL_STATUS = "SAVE_ADD_GROUP_MODAL_STATUS";
export const SAVE_ADD_GROUP_MODAL_DATA = "SAVE_ADD_GROUP_MODAL_DATA";
export const REQUEST_SEND_ADD_GROUP_DATA_SAGA = "REQUEST_SEND_ADD_GROUP_DATA_SAGA";
export const REQUEST_SEND_EDIT_GROUP_DATA_SAGA = "REQUEST_SEND_EDIT_GROUP_DATA_SAGA";
export const REQUEST_DELETE_GROUP_SAGA = "REQUEST_DELETE_GROUP_SAGA";

// PROBES
export const REQUEST_IO_TYPES_SAGA = "REQUEST_IO_TYPES_SAGA";
export const REQUEST_PROBES_TYPES_SAGA = "REQUEST_PROBES_TYPES_SAGA";
export const REQUEST_SENSOR_LIST_SAGA = "REQUEST_SENSOR_LIST_SAGA";
export const REQUEST_PINS_LIST_SAGA = "REQUEST_PINS_LIST_SAGA";
export const REQUEST_CREATE_PROBE_SAGA = "REQUEST_CREATE_PROBE_SAGA";

// SENSORS

export const REQUEST_SENSOR_DETAILS_SAGA = "REQUEST_SENSOR_DETAILS_SAGA";
export const REQUEST_UPDATE_SENSOR_DETAILS_SAGA = "REQUEST_UPDATE_SENSOR_DETAILS_SAGA";
export const STORE_SENSOR_CONFIG_DRAFT = "STORE_SENSOR_CONFIG_DRAFT";
export const RESET_DRAFT_SENSOR_DATA = "RESET_DRAFT_SENSOR_DATA";
export const REQUEST_DELETE_SENSOR_SAGA = "REQUEST_DELETE_SENSOR_SAGA";
export const REQUEST_ACKNOWLEDGE_POWER = "REQUEST_ACKNOWLEDGE_POWER";
export const REQUEST_RESET_LIMIT_SENSOR = "REQUEST_RESET_LIMIT_SENSOR";

// CUSTOMERS
export const REQUEST_GET_CUSTOMERS_LIST_SAGA = "REQUEST_GET_CUSTOMERS_LIST_SAGA";
export const SAVE_GET_CUSTOMERS_LIST = "SAVE_GET_CUSTOMERS_LIST";
export const GET_CUSTOMERS_LABEL_VALUE_LIST = "GET_CUSTOMERS_LABEL_VALUE_LIST";
export const STORE_CUSTOMERS_LABEL_VALUE_LIST = "STORE_CUSTOMERS_LABEL_VALUE_LIST";
export const REQUEST_SEND_CUSTOMER_DATA_SAGA = "REQUEST_SEND_CUSTOMER_DATA_SAGA";

// CONTACTS SAVE_GET_CONTACTS_LIST
export const REQUEST_GET_CONTACTS_LIST_SAGA = "REQUEST_GET_CONTACTS_LIST_SAGA";
export const SAVE_GET_CONTACTS_LIST = "SAVE_GET_CONTACTS_LIST";
export const SAVE_ADD_CONTACT_MODAL_STATUS = "SAVE_ADD_CONTACT_MODAL_STATUS";
export const SAVE_ADD_CONTACT_MODAL_DATA = "SAVE_ADD_CONTACT_MODAL_DATA";
export const REQUEST_SEND_CONTACT_DATA_SAGA = "REQUEST_SEND_CONTACT_DATA_SAGA";
export const REQUEST_DELETE_CONTACT_SAGA = "REQUEST_DELETE_CONTACT_SAGA";
export const REQUEST_RESET_PF_CONFIG = "REQUEST_RESET_PF_CONFIG";

// ALERTS

export const REQUEST_ALERTS_SAGA = "REQUEST_ALERTS_SAGA";
export const REQUEST_SENSOR_ALERTS_SAGA = "REQUEST_SENSOR_ALERTS_SAGA";
export const SAVE_ALERTS_LIST_DATA = "SAVE_ALERTS_LIST_DATA";
export const REQUEST_DOWNTIME_CREATE_DATA = "REQUEST_DOWNTIME_CREATE_DATA";
export const STORE_DOWNTIME_CREATE_DATA = "STORE_DOWNTIME_CREATE_DATA";
export const REQUEST_METRIC_CREATE_DATA = "REQUEST_METRIC_CREATE_DATA";
export const STORE_METRIC_CREATE_DATA = "STORE_METRIC_CREATE_DATA";
export const REQUEST_METRIC_FIELD = "REQUEST_METRIC_FIELD";
export const STORE_METRIC_FIELD = "STORE_METRIC_FIELD";
export const UPDATE_CREATE_ALERT_DATA = "UPDATE_CREATE_ALERT_DATA";
export const STORE_SENSORS_FOR_ALERT = "STORE_SENSORS_FOR_ALERT";
export const CREATE_DOWNTIME_ALERT = "CREATE_DOWNTIME_ALERT";
export const CREATE_SENSOR_DOWNTIME_ALERT = "CREATE_SENSOR_DOWNTIME_ALERT";
export const CREATE_METRIC_ALERT = "CREATE_METRIC_ALERT";
export const DELETE_ALERT_DATA = "DELETE_ALERT_DATA";
export const DELETE_SENSOR_ALERT_DATA = "DELETE_SENSOR_ALERT_DATA";
export const TOGGLE_ALARM_STATE = "TOGGLE_ALARM_STATE";
export const TOGGLE_SENSOR_ALARM_STATE = "TOGGLE_SENSOR_ALARM_STATE";
export const REQUEST_DOWNTIME_GRAPH = "REQUEST_DOWNTIME_GRAPH";
export const REQUEST_SENSOR_DOWNTIME_GRAPH = "REQUEST_SENSOR_DOWNTIME_GRAPH";
export const REQUEST_SENSOR_LIST = "REQUEST_SENSOR_LIST";
export const REQUEST_METRIC_GRAPH = "REQUEST_METRIC_GRAPH";
export const REQUEST_ALARM_HISTORY_LOGS = "REQUEST_ALARM_HISTORY_LOGS";
export const REQUEST_SENSOR_ALERT_HISTORY_LOGS = "REQUEST_SENSOR_ALERT_HISTORY_LOGS";
export const STORE_ALARM_HISTORY_LOGS = "STORE_ALARM_HISTORY_LOGS";
export const REQUEST_ALARM_HISTORY = "REQUEST_ALARM_HISTORY";
export const REQUEST_SENSOR_ALERT_HISTORY = "REQUEST_SENSOR_ALERT_HISTORY";
export const ALERT_HANDOFF = "ALERT_HANDOFF";
export const SENSOR_ALERT_HANDOFF = "SENSOR_ALERT_HANDOFF";

//Theme
export const STORE_THEME = "STORE_THEME";

// NotificationMenu
export const REQUEST_NOTIFICATIONS = "REQUEST_NOTIFICATIONS";
export const STORE_NOTIFICATIONS = "STORE_NOTIFICATIONS";
export const MARK_NOTIFICATION_READ = "MARK_NOTIFICATION_READ";
export const MARK_ALL_NOTIFICATION_READ = "MARK_ALL_NOTIFICATION_READ";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";

//Advanced tab
export const REQUEST_ADVANCED_PROBE_TYPES = "REQUEST_ADVANCED_PROBE_TYPES";
export const STORE_ADVANCED_PROBE_TYPES = "STORE_ADVANCED_PROBE_TYPES";
export const REQUEST_SLAVE_LIST = "REQUEST_SLAVE_LIST";
export const STORE_SLAVE_LIST = "STORE_SLAVE_LIST";
export const UPDATE_SLAVE = "UPDATE_SLAVE";

// User settings
export const SAVE_USER_SETTINGS = "SAVE_USER_SETTINGS";

//Tools tab
export const CHANGE_EMAIL_TRANSMISSION_CONFIG = "CHANGE_EMAIL_TRANSMISSION_CONFIG";
export const REQUEST_CELLULAR_MODEM = "REQUEST_CELLULAR_MODEM";
export const STORE_CELLULAR_MODEM = "STORE_CELLULAR_MODEM";
export const SAVE_CELLULAR_MODEM = "SAVE_CELLULAR_MODEM";

// Webhooks
export const REQUEST_WEBHOOKS = "REQUEST_WEBHOOKS";
export const SAVE_WEBHOOKS = "SAVE_WEBHOOKS";
export const CREATE_UPDATE_WEBHOOK = "CREATE_UPDATE_WEBHOOK";
export const DELETE_WEBHOOK = "DELETE_WEBHOOK";
export const REQUEST_WEBHOOK_DELIVERY_LOGS = "REQUEST_WEBHOOK_DELIVERY_LOGS";
export const SAVE_WEBHOOK_DELIVERY_LOGS = "SAVE_WEBHOOK_DELIVERY_LOGS";

//Clone Profile
export const CLONE_PROFILE = "CLONE_PROFILE";
export const CLONE_STARTED = "CLONE_STARTED";
export const CLONE_PROGRESS_UPDATED = "CLONE_PROGRESS_UPDATED";
export const CLONE_SENSORS_RESET = "CLONE_SENSORS_RESET";

//Event Rule
export const REQUEST_EVENT_RULES = "REQUEST_EVENT_RULES";
export const SAVE_EVENT_RULES = "SAVE_EVENT_RULES";
export const CREATE_UPDATE_EVENT_RULE = "CREATE_UPDATE_EVENT_RULE";
export const DELETE_EVENT_RULE = "DELETE_EVENT_RULE";
export const REQUEST_CONTENT_TYPES = "REQUEST_CONTENT_TYPES";
export const SAVE_CONTENT_TYPES = "SAVE_CONTENT_TYPES";
export const REQUEST_EVENT_FIELD_TYPES = "REQUEST_EVENT_FIELD_TYPES";
export const SAVE_EVENT_FIELD_TYPES = "SAVE_EVENT_FIELD_TYPES";
export const REQUEST_EVENT_WEBHOOKS = "REQUEST_EVENT_WEBHOOKS";
export const SAVE_EVENT_WEBHOOKS = "SAVE_EVENT_WEBHOOKS";
// Custom Fields
export const CREATE_UPDATE_CUSTOM_FIELDS = "CREATE_UPDATE_CUSTOM_FIELDS";
export const REQUEST_CUSTOM_FIELDS = "REQUEST_CUSTOM_FIELDS";
export const STORE_CUSTOM_FIELDS = "STORE_CUSTOM_FIELDS";
export const DELETE_CUSTOM_FIELDS = "DELETE_CUSTOM_FIELDS";
export const REQUEST_OBJECT_TYPES = "REQUEST_OBJECT_TYPES";
export const STORE_OBJECT_TYPES = "STORE_OBJECT_TYPES";
export const REQUEST_RELATED_OBJECT_TYPES = "REQUEST_RELATED_OBJECT_TYPES";
export const STORE_RELATED_OBJECT_TYPES = "STORE_RELATED_OBJECT_TYPES";
export const REQUEST_FIELD_TYPES = "REQUEST_FIELD_TYPES";
export const STORE_FIELD_TYPES = "STORE_FIELD_TYPES";
export const CREATE_UPDATE_CUSTOM_FIELD_CHOICES = "CREATE_UPDATE_CUSTOM_FIELD_CHOICES";
export const REQUEST_CUSTOM_FIELD_CHOICES = "REQUEST_CUSTOM_FIELD_CHOICES";
export const STORE_CUSTOM_FIELD_CHOICES = "STORE_CUSTOM_FIELD_CHOICES";
export const DELETE_CUSTOM_FIELD_CHOICES = "DELETE_CUSTOM_FIELD_CHOICES";
export const REQUEST_CUSTOM_FIELD_CHOICES_LABEL_VALUE =
  "REQUEST_CUSTOM_FIELD_CHOICES_LABEL_VALUE";
export const STORE_CUSTOM_FIELD_CHOICES_LABEL_VALUE =
  "STORE_CUSTOM_FIELD_CHOICES_LABEL_VALUE";

// Extras
export const REQUEST_SCOPE = "REQUEST_SCOPE";
export const STORE_SCOPE = "STORE_SCOPE";
export const REQUEST_CONTROLLERS_FOR_SCOPE = "REQUEST_CONTROLLERS_FOR_SCOPE";
export const STORE_CONTROLLERS_FOR_SCOPE = "STORE_CONTROLLERS_FOR_SCOPE";
